export default "__VITE_ASSET__BFG0z$bh__"